export enum FeedbackType {
  BUG = 'bug',
  SUGGESTION = 'suggestion',
  PROMOTION = 'promotion',
  CREATOR = 'creator',
  OTHER = 'other'
}

export enum FeedbackStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved'
}